<template>
  <base-page-layout class="usuarios" title="Usuários">
    <v-layout>
      <v-spacer />
      <mf-button icon="add" class="mb-3" label="Novo usuário" @click="openNewUser" />
    </v-layout>
    <v-card>
      <v-card-title class="pa-5">
        <v-row no-gutters>
          <v-col cols="9">
            <span class="table-card-title"> Usuários cadastrados </span>
          </v-col>
          <v-col cols="3">
            <mf-search v-model="search" class="pt-0 mt-0" hide-details placeholder="Busca" width="310px" />
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="px-5 pb-5">
        <paginated-data-table
          ref="table"
          :class="{ 'user-table': $getAllowedModules()['operational_performance'] }"
          :headers="headers"
          :search="search"
          :query="query"
          query-main-property-name="users"
          query-name="getPlatformUsers"
        >
          <template v-if="$getAllowedModules()['operational_performance']" #header>
            <thead>
              <tr class="headers-grouping">
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th class="headers-grouping__item" colspan="3">Acesso a dados sensíveis</th>
              </tr>
            </thead>
          </template>
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item.name }}</td>
              <td>{{ item.email }}</td>
              <td>
                <span :class="item.active ? 'status-ativo' : 'status-inativo'">{{ item.active ? 'Ativo' : 'Inativo' }}</span>
              </td>
              <td>
                <span :class="item.active ? 'status-ativo' : 'status-inativo'">{{ item.emailConfirmed ? 'Confirmado' : 'Não confirmado' }}</span>
              </td>
              <td>
                <span :class="item.active ? 'status-ativo' : 'status-inativo'">{{ isAccessSensitiveData(item) ? 'Sim' : 'Não' }}</span>
              </td>
              <td v-if="$getAllowedModules()['operational_performance']">
                <span :class="item.active ? 'status-ativo' : 'status-inativo'">{{ isAccessSensitiveDataEmployees(item) ? 'Sim' : 'Não' }}</span>
              </td>
              <td align="right">
                <v-menu v-if="userCanSeeMenu(item)">
                  <template v-slot:activator="{ on }">
                    <mf-button color="cinza-0" icon="more_vert" type="icon" v-on:click.native="on.click" />
                  </template>

                  <v-list>
                    <v-list-item :to="`/usuarios/permissionamento/${item.email}`">
                      <v-list-item-content>
                        <v-list-item-title>Permissionamento</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item @click="openEditUser(item)">
                      <v-list-item-content>
                        <v-list-item-title>
                          <v-list-item-title>Editar</v-list-item-title>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item @click="enableDisableUser(item)">
                      <v-list-item-content>
                        <v-list-item-title>{{ item.active === false ? 'Ativar' : 'Desativar' }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item @click="openLogsModal(item._id)">
                      <v-list-item-content>
                        <v-list-item-title>Logs</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
        </paginated-data-table>
      </v-card-text>
    </v-card>
    <user-form v-model="dialog" :email="selectedUser.email" @get-data="getUsers" />
    <logs-modal v-model="logsDialog" tags="USER" logTitle="usuarios" :idItem="userId" />
  </base-page-layout>
</template>

<script>
import PaginatedDataTable from '@/components/PaginatedDataTable.vue'
import UserForm from '@/modules/usuarios/views/components/UserForm.vue'
import BasePageLayout from '@/components/BasePageLayout.vue'
import { QUERY_GET_USERS, MUTATION_UPDATE_USER } from '@/modules/usuarios/graphql'
import LogsModal from '@/components/logs-modal/LogsModal.vue'

export default {
  components: {
    BasePageLayout,
    PaginatedDataTable,
    UserForm,
    LogsModal,
  },
  data: () => ({
    search: '',
    logsDialog: false,
    dialog: false,
    userId: '',
    selectedUser: {},
  }),
  computed: {
    query() {
      return QUERY_GET_USERS
    },
    headers() {
      if (this.$getAllowedModules()['operational_performance']) {
        return [
          {
            text: 'Nome',
            sortable: false,
            align: 'left',
          },
          {
            text: 'Email',
            sortable: false,
            align: 'left',
          },
          {
            text: 'Status',
            sortable: false,
            align: 'left',
          },
          {
            text: 'E-mail confirmado',
            sortable: false,
            align: 'left',
          },
          {
            text: 'Consumidores',
            sortable: false,
            align: 'left',
            class: 'left-line',
          },
          {
            text: 'Funcionários',
            sortable: false,
            align: 'left',
          },
          {
            text: '',
            sortable: false,
            align: 'left',
          },
        ]
      } else {
        return [
          {
            text: 'Nome',
            sortable: false,
          },
          {
            text: 'Email',
            sortable: false,
          },
          {
            text: 'Status',
            sortable: false,
          },
          {
            text: 'E-mail confirmado',
            sortable: false,
          },
          {
            text: 'Acesso a dados sensíveis',
            sortable: false,
          },
          {
            text: '',
            sortable: false,
            align: 'right',
          },
        ]
      }
    },
  },
  methods: {
    openEditUser(user) {
      this.selectedUser = user
      this.dialog = true
    },
    async enableDisableUser(user) {
      const confirmed = await this.$confirm({
        title: `${!user.active ? 'Ativar' : 'Desativar'} usuário`,
        message: `Você tem certeza que deseja ${!user.active ? 'ativar' : 'desativar'} o usuário?`,
        confirmText: !user.active ? 'Ativar' : 'Desativar',
        confirmColor: 'primary',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)

      if (!confirmed) return
      user.active = !user.active
      try {
        await this.$apollo.mutate({
          mutation: MUTATION_UPDATE_USER,
          variables: user,
        })
        this.$snackbar({ message: `Usuário ${user.active ? 'ativado' : 'desativado'} com sucesso` })
      } catch (error) {
        this.$snackbar({ message: `Não foi possível ${user.active ? 'ativar' : 'desativar'} este usuário` })
        user.active = !user.active
      }
    },
    openNewUser() {
      this.selectedUser = {}
      this.dialog = true
    },
    getUsers() {
      this.$refs.table.waitAndGetData()
    },
    isAccessSensitiveData(user) {
      return user?.permissions?.crm?.accessSensitiveData
    },
    isAccessSensitiveDataEmployees(user) {
      return user?.permissions?.crm?.accessSensitiveDataEmployees
    },
    userCanSeeMenu(user) {
      const {
        permissions: { crm, ecommerce },
      } = user

      return (
        (this.$getLoggedUser().has_club && !!crm.permissions.length) ||
        (this.$getIsEcommerce() && !!ecommerce.permissions.length) ||
        this.$getLoggedUser().has_mercapromo
      )
    },
    openLogsModal(id) {
      this.userId = id
      this.logsDialog = true
    },
  },
}
</script>

<style lang="scss">
.usuarios {
  .status-ativo {
    color: $verde-0;
  }
  .status-inativo {
    opacity: 0.38;
  }
}
.user-table {
  margin-top: 15px;
  .table-top {
    display: flex;
    padding: 24px 24px 32px;
    &-csv {
      font-size: 12px;
      letter-spacing: 0.01em;
      color: $marca-0-l40 !important;
      text-transform: none;
      -webkit-text-decoration-line: none;
      text-decoration-line: none;
      margin-right: 20px;
      align-self: center;
    }
    &-search {
      max-width: 260px;
    }
  }
  .headers-grouping {
    th {
      height: 21px;
      border-bottom: none !important;
      font-size: 14px;
      color: $cinza-d20 !important;
      padding-bottom: 8px;
    }
    &__item {
      border-left: 1px solid #9a9a9a !important;
      font-weight: 400;
    }
  }
  th {
    padding-bottom: 11px;
    border-bottom: 1px solid #9a9a9a !important;
    &.text-left {
      font-size: 12px;
      line-height: 14px;
      color: $cinza-d10;
      font-weight: 400;
      padding-bottom: 11px;
      height: 14px;
    }
  }
  .left-line {
    border-left: 1px solid $cinza-l30;
  }
  .v-data-table__progress th {
    padding: 0;
  }
}
</style>
